import Box from 'components/Box';
import React from 'react';
import './Divider.css';

const Divider = () => {
  return <Box data-testid="divider" className="Divider" backgroundColor="lightGrey" />;
};

export default Divider;
